import React, {useState, useEffect} from 'react';

const NewConversationModal = ({isOpen,onClose, onCreateConversation, onSearchClientsByPhone})=>
{
    const [phoneNumber, setPhoneNumber] = useState('');
    const [contactName, setContactName] = useState('');
    const [loading, setLoading]=useState(false);

     // Lista de posibles clientes encontrados
    const [possibleClients, setPossibleClients] = useState([]);
    const [selectedClient, setSelectedClient] = useState('');
    const [checkingClients, setCheckingClients] = useState(false);

    useEffect(() => {
        const searchClients = async () => {
            if (!phoneNumber.trim() || phoneNumber.trim().length < 8) {
                setPossibleClients([]);
                setSelectedClient('');
                return;
            }

            try {
                setCheckingClients(true);
                const clients = await onSearchClientsByPhone(phoneNumber.trim());
                setPossibleClients(clients || []);

                // Si hay un solo cliente, autocompletamos
                if (clients?.length === 1) {
                    setSelectedClient(clients[0].idCliente);
                    setContactName(clients[0].nombreCompleto);
                } else {
                    setSelectedClient('');
                    setContactName('');
                }
            } catch (error) {
                console.error(error);
            } finally {
                setCheckingClients(false);
            }
        };

        searchClients();
    }, [phoneNumber, onSearchClientsByPhone]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if(!phoneNumber.trim()) return;

        try{
            setLoading(true);
            await onCreateConversation(phoneNumber.trim(), contactName.trim() || null, selectedClient || null );
            setPhoneNumber('');
            setContactName('');
            setPossibleClients([]);
            setSelectedClient('');
            onClose();
            
        }catch(error){
            alert('Error creando conversacion');
        }finally{
            setLoading(false);
        }
    };

    if(!isOpen) return null;

    return(
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={e => e.stopPropagation()}>
                <div className="modal-header">
                    <h3>Nueva Conversación</h3>
                    <button onClick={onClose} className="close-modal-btn">×</button>
                </div>
                
                <form onSubmit={handleSubmit} className="modal-form">
                    <div className="form-group">
                        <label>Número de WhatsApp *</label>
                        <input
                            type="text"
                            value={phoneNumber}
                            onChange={(e) => setPhoneNumber(e.target.value)}
                            placeholder="50498765432"
                            required
                        />
                    </div>
                    
                    <div className="form-group">
                        <label>Nombre del Contacto</label>
                        {checkingClients ? (
                            <div>Cargando clientes...</div>
                        ) : possibleClients.length > 1 ? (
                            <select
                                className='contact-info-display'
                                style={{ width: "100%" }}
                                value={selectedClient}
                                onChange={e => {
                                    const clienteId = e.target.value;
                                    setSelectedClient(clienteId);

                                    const client = possibleClients.find(c => c.idCliente === Number(clienteId));
                                    setContactName(client ? client.nombreCompleto : '');
                                }}
                            >
                                 <option value="">Seleccione un cliente</option>
                                {possibleClients.map(client => (
                                    <option key={client.idCliente} value={client.idCliente}>
                                        {client.nombreCompleto}
                                    </option>
                                ))}
                            </select>
                        ) : (
                        <input
                            type="text"
                            value={contactName}
                            onChange={(e) => setContactName(e.target.value)}
                            placeholder="Juan Pérez"
                        />
                        )}
                    </div>
                    
                    <div className="modal-actions">
                        <button type="button" onClick={onClose} disabled={loading}>
                            Cancelar
                        </button>
                        <button type="submit" disabled={loading || !phoneNumber.trim()}>
                            {loading ? 'Creando...' : 'Crear Conversación'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};
export default NewConversationModal;